import React, { forwardRef, useState } from 'react';
import { Input, Button } from '@chakra-ui/react';
import { useSharedExperiencesApi } from '../../lib/useSharedExperiencesApi';
import useTranslation from '../../../lib/i18n/useTranslation';

const ExperienceGroupInSharedExperienceNameForm = forwardRef(({
  groupId,
  group,
  onSubmitting,
  onSubmitted,
  onValidityChange,
  hideSave = false
}, ref) => {
  const { t } = useTranslation();
  const [name, setName] = useState(group?.name || '');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const sharedExperiencesApi = useSharedExperiencesApi();
  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    if (!name.trim()) return;
    try {
      setIsSubmitting(true);
      if (onSubmitting) onSubmitting();
      await sharedExperiencesApi.updateSharedExperienceGroup(groupId, {
        name: name.trim()
      });
      if (onSubmitted) onSubmitted();
    } catch (error) {
      console.error('Error updating group name:', error);
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleNameChange = (e) => {
    const newName = e.target.value;
    setName(newName);
    if (onValidityChange) {
      onValidityChange(newName.trim().length > 0);
    }
  };
  return (
    <form onSubmit={handleSubmit}>
      <Input
        value={name}
        onChange={handleNameChange}
        placeholder={t('group.groupNamePlaceholder')}
        mb={3}
        autoFocus
      />
      <Button
        style={{
          display: hideSave ? 'none' : 'inherit',
        }}
        type="submit"
        variant="greenFill"
        isLoading={isSubmitting}
        isDisabled={!name.trim()}
        ref={ref}
      >
        Save
      </Button>
    </form>
  );
});
ExperienceGroupInSharedExperienceNameForm.displayName = 'ExperienceGroupInSharedExperienceNameForm';
export default ExperienceGroupInSharedExperienceNameForm; 